import {AppPageErrorMessage} from './app.page.error.message';
/**
 * 错误提示消息
 */
export class AppPageValidates {
    errorMessage: Array<AppPageErrorMessage> = new Array<AppPageErrorMessage>();
}